/* @flow */
import React from 'react';

import ExpandableSiteServicesMenu from './ExpandableSiteServicesMenu';
import PopoverSiteServicesMenu from './PopoverSiteServicesMenu';
import withBreakpoint from '../withBreakpoint';

class AnimatedSiteServicesMenuImpl extends React.Component<{
  menu: any,
  popoverTarget: HTMLElement,
  breakpoint: string,
  onShow: Function,
  onHide: Function,
}> {
  show() {
    this.menu.show();
  }

  hide(forcePopover = false) {
    this.menu.hide(forcePopover);
  }

  toggle(forcePopover = false) {
    this.menu.toggle(forcePopover);
  }

  render() {
    let { breakpoint, popoverTarget, ...props } = this.props;
    return breakpoint === 'small' ? (
      <ExpandableSiteServicesMenu ref={ref => (this.menu = ref)} {...props} />
    ) : (
      <PopoverSiteServicesMenu
        target={popoverTarget}
        wrappedComponentRef={ref => (this.menu = ref)}
        {...props}
      />
    );
  }
}

export default withBreakpoint(AnimatedSiteServicesMenuImpl);



// WEBPACK FOOTER //
// ./src/ui/components/chrome/AnimatedSiteServicesMenu.js